import BaseTracker from './base-tracker';

export default class AdPointTracker extends BaseTracker {
  _trackable = false;
  _tracked = false;
  _point = 0;

  start() {
    this._point = this._toAbsoluteTime(this._event.startTimeInSeconds);

    this._player.addEventListener('ontimeupdate', this._onTimeupdate);
    this._player.addEventListener('seeked', this._reset);

    this._reset();
  }

  _reset = () => {
    this._trackable = this._point > this._player.model.currentTime;
  };

  _onTimeupdate = () => {
    if (!this._tracked && this._trackable && this._player.model.currentTime >= this._point) {
      this._tracked = true;
      this.track();
    }
  };

  stop() {
    this._player.removeEventListener('ontimeupdate', this._onTimeupdate);
    this._player.removeEventListener('seeked', this._reset);
  }
}
